import React, { useEffect, useState } from 'react'
import { checkList, fetchBlackList, isIterableArray, useClientInfo } from '../../../block-slider/utils'
import { Alert, Col, Row, Spinner, Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import fontColorContrast from 'font-color-contrast'
import axios from 'axios'
import ConfirmEmailForm from './ConfirmEmailForm'

const FormAddCard = ({ data, userInfo, query, pageData, warningMassage, setWarningMassage }) => {

    const { receipt, number_card } = query

    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors, isValid },
    } = useForm({
        mode: 'onBlur'
    })


    const {
        button_color,
        text_1,
        text_2,
        text_3,
        text_4,
        text_5,
        text_6,
        text_7,
        text_8,
        text_9,
        text_10 = 'Карта успешно добавлена',
        text_13 = 'Добавление карты',

    } = data?.setting


    const [isAlertSuccess, setIsAlertSuccess] = useState(false);
    const [isAlertError, setIsAlertError] = useState(false);
    const [textOnError, setTextOnError] = useState('');


    const [isConfirmMode, setIsConfirmMode] = useState(false)
    const [confirmResendData, setConfirmResendData] = useState(null)

    const [isLoading, setIsLoading] = useState(false); // загрузка при отправке
    const [itemsData, setItemsData] = useState({
        checkboxs: [],
        inputs: [],
    });

    const [blackList, setBlackList] = useState(null)
    useEffect(() => {
        fetchBlackList(10).then(res => {
            setBlackList(res)
        })
    }, [])

    useEffect(() => {
        if (receipt) {
            if (receipt) {
                setValue('userCheck', receipt)
            }
        }
    }, [setValue, receipt]);
    useEffect(() => {
        if (number_card) {
            if (number_card) {
                setValue('userNumberCard', number_card)
            }
        }
    }, [setValue, number_card]);

    useEffect(() => {
        if (data) {
            dataToFormat(data.items)
        }
    }, [data])
    const dataToFormat = (data) => {
        const checkboxItems = data.reduce((acc, item, index) => {
            if (item.type === 1) acc.push({
                ...item,
                fieldName: `_checkbox_${index}`,
            })
            return acc
        }, [])
        const inputItems = data.reduce((acc, item, index) => {
            if (item.type > 1 && item.type < 7) acc.push({
                ...item,
                fieldName: `_input_${index}`,
            })
            if (item.type === 9) acc.push({
                ...item,
                fieldName: `userNumberCard`,
            })
            if (item.type === 10) acc.push({
                ...item,
                fieldName: `userCheck`,
            })
            return acc
        }, [])
        setItemsData({
            checkboxs: checkboxItems,
            inputs: inputItems,
        })

    }
    const onSubmit = (formData) => {
        const formatter = (arr) => {
            return arr.reduce((acc, item) => {
                const val = {
                    forEmail: item.forEmail,
                    value: formData[item.fieldName]
                }
                acc.push(val)
                return acc
            }, [])
        }

        const formattedCheckboxs = formatter(itemsData.checkboxs)
        const formattedInputs = formatter(itemsData.inputs)

        const sendData = {
            checkboxs: formattedCheckboxs,
            inputs: formattedInputs
        }

        handleSend(sendData)
    }

    const { fetchClientInfo } = useClientInfo()

    const handleSend = async (sendData) => {
        const info = await fetchClientInfo()

        sendData.clientInfo = {
            ...info,
            page_name: pageData.name_rkn,
            form_name: data.name_rkn
        }


        setIsLoading(true)
        axios
            .post(`${process.env.REACT_APP_API_BASE}/registration/new-card`, sendData)
            .then((response) => {
                if (response?.data && response.data?.res) {
                    if (response.data.res === 'Success') {
                        setIsConfirmMode(true)
                        setConfirmResendData(sendData)
                        setIsAlertSuccess(true)
                        setIsAlertError(false)
                    }
                    if (response.data.res === 'Error') {
                        setIsAlertError(true)
                        const errText = data?.setting?.[response.data?.msgKey] || 'Что-то пошло не так, попробуйте повторить позже'
                        setTextOnError(errText)
                    }
                }
                // reset()
            })
            .catch((err) => {
                console.log(err)
                setIsAlertError(true)
                setTextOnError('Что-то пошло не так')
            })
            .finally(() => {
                setIsLoading(false)
            });
    }

    const RenderFormItems = ({ items }) => (
        items.map((item, key) => {
            switch (item.type) {
                case 1: return <CheckboxItem key={key} item={item} />
                case 2: return item.forEmail === 'email' ? EmailUserCol(item) : ''
                default: return '';
            }
        })
    )

    const RenderCardInfo = ({ items }) => (
        items.map((item, key) => {
            switch (item.type) {
                case 9: return UserCheckCol(item)
                // case 10: return UserCheckCol(item)
                default: return '';
            }
        })
    )
    const CheckboxItem = ({ item }) => (
        <Col className='mb-3'>
            <Form.Check
                className='d-inline-block'
                type="checkbox"
                label={<span dangerouslySetInnerHTML={{ __html: item.text }} />}
                id={item.fieldName}
                {...register(item.fieldName, { required: !!item.required })}
            />

            {
                errors[item.fieldName] &&
                <Form.Control.Feedback type="invalid" className='d-block'>
                    Обязательно к заполнению
                </Form.Control.Feedback>
            }
        </Col>
    )

    const UserCheckCol = (item) => (
        <div style={{ marginRight: 60 }} key={item.fieldName}>
            <Controller
                name={item.fieldName}
                control={control}
                rules={{
                    required: !!item.required
                }}
                render={({ field }) => {
                    return (
                        <>
                            <p style={{ fontFamily: "Arial", fontWeight: 500, marginBottom: '0.65em' }}>{item.text}</p>
                            <p className='text-muted' style={{ fontFamily: "Arial", fontWeight: 500, fontSize: '1.3em' }}>{field.value}</p>
                            <Form.Control
                                {...field}
                                readOnly={true}
                                placeholder={item.text}
                                type="hidden"
                            />
                        </>
                    )
                }}
            />
        </div>
    )
    const EmailUserCol = (item) => {
        const emailDefault = userInfo?.email
        if (emailDefault) setValue(item.fieldName, emailDefault)
        return (
            <Col md={12} className='mb-2' key={item.fieldName}>
                <Form.Control
                    disabled={!!emailDefault}
                    placeholder={item.text}
                    type="email"
                    {...register(item.fieldName, {
                        required: !!item.required,
                        pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        validate: (value) => {
                            return !checkList(blackList, value)
                        },
                        // pattern: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/g
                    })}
                />
                {
                    errors?.[item.fieldName]?.type === 'required' &&
                    <Form.Control.Feedback type="invalid" className='d-block'>
                        Обязательно к заполнению
                    </Form.Control.Feedback>
                }
                {
                    errors?.[item.fieldName]?.type === 'pattern' &&
                    <Form.Control.Feedback type="invalid" className='d-block'>
                        E-mail заполнен некорректно
                    </Form.Control.Feedback>
                }
                {
                    errors?.[item.fieldName]?.type === "validate" &&
                    <Form.Control.Feedback type="invalid" className='d-block'>
                        {blackList?.text || "Недопустимое значение E-mail"}
                    </Form.Control.Feedback>
                }
            </Col>
        )
    }

    return (
        <div>
            {/* <div style={{ maxWidth: 600, marginLeft: 'auto', marginRight: 'auto' }}> */}

            {
                isConfirmMode ?
                    <ConfirmEmailForm
                        data={data}
                        handleResend={() => {
                            handleSend(confirmResendData)
                        }}
                        confirmResendData={confirmResendData}
                    />
                    :
                    <Row className='justify-content-center'>
                        <Col md={8} lg={8} xl={6} className='mb-2' >

                            {data.title && <div className='title' dangerouslySetInnerHTML={{ __html: data.title }} />}

                            <form onSubmit={handleSubmit(onSubmit)}>
                                {
                                    warningMassage &&
                                    <Alert variant={'warning'} onClose={() => {
                                        setWarningMassage(null)
                                    }} dismissible>
                                        <p className='mb-0'>{warningMassage}</p>
                                    </Alert>
                                }
                                {
                                    isAlertSuccess &&
                                    <Alert variant={'success'} onClose={() => setIsAlertSuccess(false)} dismissible>
                                        <div dangerouslySetInnerHTML={{ __html: text_10 }} />
                                    </Alert>
                                }
                                {
                                    isAlertError &&
                                    <Alert variant={'danger'} onClose={() => {
                                        setIsAlertError(false)
                                        setTextOnError('')
                                    }} dismissible>
                                        <Alert.Heading style={{ fontSize: '1.15rem' }}>Ошибка</Alert.Heading>
                                        <p className='mb-0'>{textOnError}</p>
                                    </Alert>
                                }
                                <div className='light buildedPage-type_8-form'>
                                    <div className='h5 mb-3' dangerouslySetInnerHTML={{ __html: text_13 }} />
                                    <Row>
                                        {
                                            isIterableArray(itemsData.inputs) &&
                                            <RenderFormItems items={itemsData.inputs} />
                                        }
                                    </Row>
                                    <hr />
                                    {
                                        isIterableArray(itemsData.inputs) &&
                                        <RenderCardInfo items={itemsData.inputs} />
                                    }
                                    <Row className='mt-3' >
                                        <Col md={6} lg={7} xxl={8}>
                                            {
                                                isIterableArray(itemsData.checkboxs) &&
                                                <RenderFormItems items={itemsData.checkboxs} />
                                            }
                                        </Col>
                                        <Col sm={12} >
                                            <button
                                                disabled={!isValid}
                                                className='btn btn-submit'
                                                type='submit'
                                                style={{
                                                    backgroundColor: button_color,
                                                    color: fontColorContrast(button_color)
                                                }}
                                            >
                                                {
                                                    isLoading ?
                                                        <Spinner animation='border' />
                                                        :
                                                        <div dangerouslySetInnerHTML={{ __html: text_2 || 'Отправить' }}></div>
                                                }
                                            </button>

                                            {
                                                text_1 &&
                                                <div className='text_under mt-3 text-center' dangerouslySetInnerHTML={{ __html: text_1 }} />
                                            }
                                        </Col>
                                    </Row>
                                </div>

                            </form>
                        </Col>
                    </Row>
            }
        </div>
    )
}

export default FormAddCard